// extracted by mini-css-extract-plugin
export default {"Container":"MappingData_Container__e6l8S","ErrorMessage":"MappingData_ErrorMessage__PuAHO"};